import Expert from "../assets/images/Expert.png";
import Support from "../assets/images/Support.png";
import HighQualityWork from "../assets/images/HighQualityWork.png";

export const ABOUT_VALUE_CARDS = [
  {
    id: "expert",
    icon: Expert,
    titleKey: "Expert & Professional",
    descriptionKey: "Always distinguished in all designs and products",
  },
  {
    id: "quality",
    icon: Support,
    titleKey: "High Quality Work",
    descriptionKey:
      "Our products conform to standard specifications and are suitable for changing weather conditions",
  },
  {
    id: "support",
    icon: HighQualityWork,
    titleKey: "24/7 Help Support",
    descriptionKey:
      "Always at your service and the goal is to always satisfy our customers",
  },
];
